import { ConsultationTypes } from 'types';

export const CONSULTATION_TYPE = {
  [ConsultationTypes.Available]: 'In-Person & Online Video',
  [ConsultationTypes.InPerson]: 'In-Person',
  [ConsultationTypes.Online]: 'Online Video',
  [ConsultationTypes.FreeConsultation]: 'Free Consultation',
};
